import { CustomerAccount, CustomerAccountTypeValue } from './customer-account.model';
import { NumberUtil } from '@ridango/core/lib/utils/number.util';

export function customerAccountIdToString(account: CustomerAccount): string {
    const id = account.id;
    return id != null ? String(id) : '';
}

export function customerAccountSortComparer(a: CustomerAccount, b: CustomerAccount): number {
    const typeA = a.type?.code;
    const typeB = b.type?.code;

    if (typeA !== typeB) {
        return typeA === CustomerAccountTypeValue.PERSONAL ? -1 : 1;
    }

    const idA = a.id;
    const idB = b.id;
    if (NumberUtil.isNumeric(idA) && NumberUtil.isNumeric(idB)) {
        return Number(idA) - Number(idB);
    }
    return customerAccountIdToString(a).localeCompare(customerAccountIdToString(b));
}
